import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, msg: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, msg: error?.message || "Unexpected error" };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Showroom error boundary:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="showroom-error-boundary"
          className="absolute inset-0 flex flex-col items-center justify-center gap-4 px-6 text-center"
          style={{ background: "#05070d" }}
        >
          <img src="/tab-seal.png" alt="TAB" className="h-16 w-16 rounded-full opacity-80" />
          <h2 className="font-display text-2xl text-white">The spatial engine hit a snag</h2>
          <p className="max-w-md text-sm text-slate-400">
            A 3D/XR component failed to render. The rest of the app is fine — reload to relaunch the
            showroom.
          </p>
          <button
            onClick={() => window.location.reload()}
            data-testid="error-reload-button"
            className="gold-btn rounded-full px-7 py-3 text-sm uppercase tracking-[0.16em]"
          >
            Reload Showroom
          </button>
          <code className="mono mt-2 max-w-md truncate text-[0.65rem] text-slate-600">{this.state.msg}</code>
        </div>
      );
    }
    return this.props.children;
  }
}
